import { Node, Parent, Text } from "mdast";
import { visit } from "unist-util-visit";

export interface SpanMeta {
  isQuote?: boolean;
}

interface TextNode extends Text {
  type: "text";
  value: string;
}

export interface EmphasisNode {
  type: "emphasis";
  data: {
    hName: string;
  };
  meta: SpanMeta;
  children: TextNode[];
}

/**
 * Remark plugin that add support for rp style "quoted text" rendering
 */
export function remarkQuotes() {
  return (tree: Node) => {
    visit(tree, "text", (node: Node, index: number, parent: Parent | null) => {
      if (!parent || !("value" in node)) return;

      const text = node.value as string;
      const quotes = findQuotesInText(text);
      if (quotes.length === 0) return;

      const newNodes: any[] = [];
      let lastIndex = 0;

      quotes.forEach(({ quote, start, end }) => {
        // Add text before the quote
        if (start > lastIndex) {
          newNodes.push({
            type: "text",
            value: text.slice(lastIndex, start)
          });
        }

        const node: EmphasisNode = {
          type: "emphasis",
          meta: {
            isQuote: true
          },
          data: {
            hName: "em"
          },
          children: [
            {
              type: "text",
              value: `"${quote.slice(1, -1)}"`
            }
          ]
        };
        newNodes.push(node);
        lastIndex = end;
      });

      // Add remaining text after last quote
      if (lastIndex < text.length) {
        newNodes.push({
          type: "text",
          value: text.slice(lastIndex)
        });
      }

      parent.children.splice(index, 1, ...newNodes);
    });
  };
}

function findQuotesInText(text: string): QuoteMatch[] {
  // Match pairs of single, double, or curly quotes
  const regex = /"([^"]+)"/g;

  const matches: QuoteMatch[] = [];
  let match: RegExpExecArray | null;

  while ((match = regex.exec(text)) !== null) {
    matches.push({
      quote: match[0],
      start: match.index,
      end: match.index + match[0].length
    });
  }

  return matches;
}

interface QuoteMatch {
  quote: string;
  start: number;
  end: number;
}
